import { render, staticRenderFns } from "./AddCompetitorDialog.vue?vue&type=template&id=2a0c3817"
import script from "./AddCompetitorDialog.vue?vue&type=script&lang=js"
export * from "./AddCompetitorDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCompetitorDialog.vue?vue&type=style&index=0&id=2a0c3817&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports